define('rebrush/components/contentbridge/tabs',[
	'jquery',
	'cartware/components/_base'
], function(
	$,
	Component
) {
	return Component.create({
		blocks:			null,

		$init: function() {
			this.blocks = $('ul.tabs');
			this.blocks.each(function() {
				var block = $(this),
					container = $('<div class="b_tabs b_tabs--close-mobile">'),
					list = $('<dl class="b_tabs__list">').appendTo(container);

				block.find("> li").each(function(i) {
					var li = $(this),
						title = li.find('.tab-title').html() || (Translator.translate('Tab') + ' ' + (i + 1)),
						dt = $('<dt class="b_tabs__tab">').appendTo(list),
						titleSpan = $('<span>').html(title).appendTo(dt),
						dd = $('<dd class="b_tabs__tab-content">').appendTo(list).html(li.html());

					if (0 === i) {
						dt.addClass('b_tabs__tab--active');
						dd.addClass('b_tabs__tab-content--active');
					}
				});

				block.after(container);
				block.remove();
			});
		}
	});
});
